// Source page context strings
export const ORDER_HISTORY_SOURCE_PAGE = 'orderHistory';
export const ORDER_DETAILS_SOURCE_PAGE = 'orderDetails';
export const ORDER_CONFIRMATION_SOURCE_PAGE = 'orderConfirmation';
export const BUY_IT_AGAIN_SOURCE_PAGE = 'buyItAgain';
export const DESIGN_FEEDBACK_REQUEST_GROUP_PAGE = 'designFeedbackRequestGroup';
export const DESIGN_FEEDBACK_CONFIRMATION_PAGE =
  'designFeedbackGroupConfirmation';
export const DESIGN_FEEDBACK_GROUP_CONFIRMATION_PAGE =
  'designFeedbackGroupConfirmation';

// Action strings
export const EDIT_ACTION = 'EDIT';
export const REORDER_ACTION = 'REORDER';
export const EXPRESS_CHECKOUT_ACTION = 'EXPRESS_CHECKOUT';

// Tracking page and event name strings.
export const ORDER_DETAILS_PAGE_NAME = 'My Account:Order Details';
export const ORDER_CONFIRMATION_PAGE_NAME = 'Checkout:Order:Confirmation';
export const ORDER_HISTORY_PAGE_NAME = 'My Account:Order History';
export const BUY_IT_AGAIN_PAGE_NAME = 'My Account:Buy It Again';
export const ORDER_FIND_MY_ORDER_PAGE_NAME = 'My Account:Find My Order';

export const CONFIRMATION_PAGE_SECTION = 'Confirmation';
export const MY_ACCOUNT_PAGE_SECTION = 'My Account';
export const CHECKOUT_PAGE_STAGE = 'Checkout';
export const MY_ACCOUNT_PAGE_STAGE = 'My Account';
export const BUY_IT_AGAIN_PAGE_ZONE = 'Buy It Again';
export const EDIT_DESIGN_AND_REORDER_CTA_VALUE = 'Edit design & reorder';
export const STUDIO_DESTINATION_PAGE_PATH = 'Studio';

export const BUY_IT_AGAIN_EXPRESS_CHECKOUT_SOURCE = `${BUY_IT_AGAIN_SOURCE_PAGE}:${EXPRESS_CHECKOUT_ACTION}`;
export const ORDER_HISTORY_EXPRESS_CHECKOUT_SOURCE = `${ORDER_HISTORY_SOURCE_PAGE}:${EXPRESS_CHECKOUT_ACTION}`;
export const ORDER_DETAILS_EXPRESS_CHECKOUT_SOURCE = `${ORDER_DETAILS_SOURCE_PAGE}:${EXPRESS_CHECKOUT_ACTION}`;
export const REORDER_PRODUCT_ADDED_TO_CART_EVENT_NAME = 'Product Added';
export const PRODUCT_LIST_VIEWED_EVENT_NAME = 'Product List Viewed';
export const NAVIGATION_CLICKED_EVENT_NAME = 'Navigation Clicked';
export const BUTTON_CLICKED_EVENT_NAME = 'Button Clicked';
export const PRODUCT_REORDERED_LABEL = 'Product Re-ordered';
export const BUY_IT_AGAIN_RETIRED_ITEMS_PRODUCT_LIST_VIEW_LABEL =
  'View Similar Items Button(s) Present in Product List';
export const VIEW_SIMILAR_ITEMS_BUTTON_CLICKED_LABEL =
  'View Similar Items Button Clicked';
export const VIEW_SIMILAR_ITEMS_NAVIGATION_DETAIL = 'View Similar Items';
export const TRACKING_URL_CLICKED_LABEL = 'Tracking Url Link Clicked';
export const TRACKING_URL_LINK_DETAIL = 'Tracking Url';
export const BUY_IT_AGAIN_RETIRED_ITEMS_PRODUCT_LIST_VIEW_LIST_ID =
  'Buy It Again Page View with Retired Product(s)';
export const ORDER_COMPLETED_SEGMENT_EVENT_NAME = 'Order Completed';
export const ORDER_ITEMS_REORDERED_ATTEMPTED_EVENT_NAME =
  'Order Reorder Attempted';
export const ITEM_LEGACY_DOC_CONVERSION_ATTEMPTED_EVENT_NAME =
  'Item Legacy Doc Conversion Attempted';
export const ORDER_VAT_INVOICE_DOWNLOAD_ATTEMPTED_EVENT_NAME =
  'Order VAT Invoice Download Attempted';
export const ORDER_VAT_INVOICE_AVAILABLE_ERROR =
  'Error Fetching Order VAT Invoice Availability';
export const ORDER_VAT_INVOICE_DOWNLOAD_ATTEMPT_SUCCEEDED_EVENT_NAME =
  'Order VAT Invoice Download Attempt Succeeded';
export const ORDER_VAT_INVOICE_DOWNLOAD_ATTEMPT_FAILED_EVENT_NAME =
  'Order VAT Invoice Download Attempt Failed';
export const LEGACY_DOCUMENT_DESIGN_TECH_DIFY_REMEDIATION_ATTEMPTED =
  'Legacy Document Design Tech DIFY Remediation Attempted';
export const LEGACY_DOCUMENT_DESIGN_TECH_DIFY_REMEDIATION_SUCCEEDED =
  'Legacy Document Design Tech DIFY Remediation Succeeded';
export const LEGACY_DOCUMENT_DESIGN_TECH_DIFY_REMEDIATION_FAILED =
  'Legacy Document Design Tech DIFY Remediation Failed';
export const LEGACY_DOCUMENT_REMEDIATION_MODAL_PRESENTED_TO_CUSTOMER =
  'Legacy Document Remediation Modal Presented To Customer';
export const DESIGN_TECH_LEGACY_MODAL_ERROR =
  'Design Tech Legacy Recreation Service Returned an Error';
export const DESIGN_TECH_LEGACY_MODAL_UNAVAILABLE =
  'Design Tech Legacy Recreation Service was Unavailable';
export const LEGACY_EDIT_DOCUMENT_URL_CONVERSION_SUCCESS_EVENT_NAME =
  'Legacy Product Edit Document URL retrieved';

export const EXPRESS_CHECKOUT_ADDED_TO_CART_EVENT_NAME =
  'Express Checkout Product Added To Cart';
